import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MyPagination = (props) => {
  const { paginationProps } = props;
  const { page = 1, setPage, maxPage = 1 } = paginationProps;

  const goToPage = (val) => setPage(val);

  const goToLastPage = () => {
    if (page !== maxPage) {
      setPage(maxPage);
    }
  };

  const goToFirstPage = () => {
    if (page > 1) {
      setPage(1);
    }
  };

  const goToNextPage = () => {
    if (page < maxPage) {
      setPage(page + 1);
    }
  };

  const goToPreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  return (
    <ul className="flex items-center gap-2 text-[#555555]">
      <li
        className={`w-6 h-6 flex items-center justify-center rounded-full text-sm ${
          page === 1
            ? "text-[#888888] cursor-not-allowed"
            : "cursor-pointer hover:bg-[#F9F9F9"
        }`}
        onClick={goToFirstPage}
      >
        <FontAwesomeIcon icon={faAngleDoubleLeft} size="sm" />
      </li>

      <li
        className={`w-6 h-6 flex items-center justify-center rounded-full text-sm ${
          page === 1
            ? "text-[#888888] cursor-not-allowed"
            : "cursor-pointer hover:bg-[#F9F9F9"
        }`}
        onClick={goToPreviousPage}
      >
        <FontAwesomeIcon icon={faAngleLeft} size="sm" />
      </li>

      {Array.from({ length: maxPage }, (_, index) => index + 1).map((c) => (
        <li
          key={c}
          className={`w-6 h-6 flex items-center justify-center rounded-full text-sm cursor-pointer ${
            c === page ? "font-bold bg-[#F2F2F2]" : "hover:bg-[#F9F9F9]"
          }`}
          onClick={() => goToPage(c)}
        >
          {c}
        </li>
      ))}

      <li
        className={`w-6 h-6 flex items-center justify-center rounded-full text-sm ${
          page === maxPage
            ? "text-[#888888] cursor-not-allowed"
            : "cursor-pointer hover:bg-[#F9F9F9"
        }`}
        onClick={goToNextPage}
      >
        <FontAwesomeIcon icon={faAngleDoubleRight} size="sm" />
      </li>

      <li
        className={`w-6 h-6 flex items-center justify-center rounded-full text-sm ${
          page === maxPage
            ? "text-[#888888] cursor-not-allowed"
            : "cursor-pointer hover:bg-[#F9F9F9"
        }`}
        onClick={goToLastPage}
      >
        <FontAwesomeIcon icon={faAngleRight} size="sm" />
      </li>
    </ul>
  );
};

export default MyPagination;
